import { FC, useEffect, useState } from 'react';
import { PageHeaderProps } from './pageHeader.type';
import { Trans } from 'react-i18next';
import Notification from '../../assets/notification.png';
import HamburgerMenu from '../../assets/hamburger.png';
import './pageHeader.css';
import DropdownMenu from '../dropDownMenu/dropDownMenu';
import { useLogoutData } from '../../hooks/useAuthData';
import { AuthTokenResponse } from '../../service/service.type';
import { validateAndDecodeAuthToken } from '../../utils/helper';
import { DropdownOption } from '../dropDownMenu/dropDownMenu.type';
import { useLocation, useNavigate } from 'react-router-dom';
import { route } from '../../service/router';
import { VenueDropdown } from './pageHeaderHelper';
import { useOrganizationContext } from '../../service/context/organizationContext';
import { IconTooltip } from '../../pages/dashboard/dashboardHelper';
import { userMenuOption } from '../../utils/constant';

const PageHeader: FC<PageHeaderProps> = (props) => {
  const [isOpenUserOption, setIsOpenUserOption] = useState<boolean>(false);
  const [decodedLoginData, setDecodedLoginData] =
    useState<AuthTokenResponse | null>(null);
  const { logout, logoutLoading } = useLogoutData();
  const location = useLocation();
  const [showVenueDropdown, setShowVenueDropdown] = useState<boolean>(false);
  const {
    groupedOrganizationData,
    selectedVenueBranch,
    updateSelectedVenueBranch,
  } = useOrganizationContext();

  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === route.dashboard) {
      setShowVenueDropdown(true);
    } else if (location.pathname === route.sweeps) {
      setShowVenueDropdown(true);
    } else if (location.pathname === route.harmReports) {
      setShowVenueDropdown(true);
    } else if (location.pathname === route.interventionReports) {
      setShowVenueDropdown(true);
    } else if (location.pathname === route.exclusionOrders) {
      setShowVenueDropdown(true);
    } else {
      setShowVenueDropdown(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const decodedData: AuthTokenResponse | null = validateAndDecodeAuthToken();

    if (decodedData) {
      setDecodedLoginData(decodedData);
    }
  }, []);

  const loadingUpdatedUserMenuOption: DropdownOption[] = userMenuOption.map(
    (item: DropdownOption) =>
      item.label === 'userManagement.user.logout'
        ? { ...item, loading: logoutLoading }
        : item,
  );

  const handleLogoutClick = async () => {
    if (decodedLoginData) {
      await logout(decodedLoginData?.email);
    }
  };

  const handleUserOptionSelect = (label: string) => {
    if (label === 'userManagement.user.logout') {
      handleLogoutClick();
    }
    if (label === 'userManagement.user.myAccount') {
      navigate(route.profile);
      setIsOpenUserOption(!isOpenUserOption);
    }
  };

  return (
    <div className="justify-between flex bg-MAIN_APP_THEME_COLOR py-8 px-12">
      <div className="flex gap-4">
        {!props.isSidebarOpen && (
          <img
            src={HamburgerMenu}
            alt="hamburger"
            className="h-4 mt-2 cursor-pointer"
            onClick={() => props.onHamburgerClick()}
          />
        )}
        <div className="text-[#1A1A1A] text-xl font-medium">
          <Trans i18nKey={props.title} />
        </div>
      </div>
      <div className="flex">
        <div className="mr-5 flex items-center justify-center">
          {showVenueDropdown && (
            <VenueDropdown
              decodedLoginData={decodedLoginData}
              groupedOrganizationData={groupedOrganizationData}
              selectedVenueBranch={selectedVenueBranch}
              updateSelectedVenueBranch={updateSelectedVenueBranch}
            />
          )}
        </div>
        <div className="notification-container">
          <IconTooltip
            text="iconLabels.notifications"
            className="tooltip-bottom"
          />
          <img src={Notification} alt="notification" className="w-4 h-3" />
        </div>
        <div className="relative inline-block">
          <div
            onClick={() => setIsOpenUserOption(!isOpenUserOption)}
            className="username-container text-[11px] font-semibold"
          >
            {props.username}
          </div>
          {isOpenUserOption && (
            <DropdownMenu
              className="right-0 w-32"
              options={loadingUpdatedUserMenuOption}
              onSelect={(label) => handleUserOptionSelect(label)}
              onClose={() => setIsOpenUserOption(!isOpenUserOption)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
